// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'

export const getData = createAsyncThunk('appAdminTransaction/getData', async params => {
  const response = await axios.get('/vt/transaction/list', {params})
  return {
    params,
    data: response.data.data.rows,
    hasChild: response.data.hasChild,
    allData: response.data.allData,
    totalPages: response.data.data.count,
    totals: response.data.totals || { settledAmount: 0, settledPlusApprovedAmount: 0, baseAmount: 0, amount: 0 }
  }
})

export const getChildUser = createAsyncThunk('appAdminUsers/getData', async params => {
  const response = await axios.get('/users/childmerchant', {params})
  return {
    params,
    data: response.data,
    totalPages: response.data.length
  }
})

export const deleteInvoice = createAsyncThunk('appAdminTransaction/deleteInvoice', async (id, { dispatch, getState }) => {
  await axios.delete('/apps/invoice/delete', { id })
  await dispatch(getData(getState().adminTransaction.params))
  return id
})

export const getUser = createAsyncThunk('appAdminCustomers/getUser', async id => {
  const response = await axios.get(`/customer/${id}`)
  return response.data.data
})

export const getCurrentUser = createAsyncThunk('appAdminUsers/getUser', async id => {
  const response = await axios.get(`/users/${id}`)
  return response.data.data
})

export const getAllMerchants = createAsyncThunk('appAdminTransaction/getAllMerchants', async () => {
  const response = await axios.get('/users/list')
  return response.data.data
})

export const appAdminTransactionSlice = createSlice({
  name: 'appAdminTransaction',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    hasChild: 0,
    merchants: [],
    totals: { settledAmount: 0, settledPlusApprovedAmount: 0, baseAmount: 0, amount: 0 }
  },
  reducers: {},
  extraReducers: builder => {
    builder.addCase(getData.fulfilled, (state, action) => {
      state.data = action.payload.data
      state.allData = action.payload.allData
      state.total = action.payload.totalPages
      state.params = action.payload.params
      state.hasChild = action.payload.hasChild
      state.totals = action.payload.totals
    })
    .addCase(getCurrentUser.fulfilled, (state, action) => {
      state.selectedUser = action.payload
    })
    .addCase(getAllMerchants.fulfilled, (state, action) => {
      state.merchants = action.payload
    })
  }
})

export default appAdminTransactionSlice.reducer
